import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import DateRange from "@material-ui/icons/DateRange";
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {serverError} from '../../redux/global'

import CustomInput from "components/CustomInput/CustomInput.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";

import {timings, titleCase} from '../../util/globalHelper';
import {getDateConverter, dashboardRouter} from '../../util/globalHelper';
import FormControl from "@material-ui/core/FormControl";
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Auth from "../../Auth";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class OneTestRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            time: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            notes: "",
            type: ""
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.generateLink = this.generateLink.bind(this);
        this.onAccept = this.onAccept.bind(this);
        this.CallReadApi = this.CallReadApi.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = (id) => {
        api.getTestRequests({_id: this.props.id.match.params.id})
            .then(json => {
                this.setState({data: json.data.data[0]}, () => {
                    this.setState({
                        start_date: this.state.data.local_date_string ? this.state.data.local_date_string : "",
                        time: this.state.data.local_start_time ? this.state.data.local_start_time : ""
                    })
                })
            }).catch(error => {
            this.setState({notFound: error});
            this.props.serverError(true);
        });
    };

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name

    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    generateLink() {
        var data = {
            "clinic_master_id": this.state.data.clinic_master_id._id,
            "clinic_id": this.state.data.clinic_id._id,
            "order_id": this.props.id.match.params.id
        };
        if (this.state.data.clinic_master_id._id !== "" && this.state.data.clinic_id._id !== "") {
            api.initiatePaymentLink(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Payment Link Sent!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    // this.props.id.history.push(dashboardRouter(`/payment/list`))
                    // this.props.id.history.push(dashboardRouter(`/appointment/view/${json.data.data._id}`))
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }


    onAccept() {
        api.acceptTest({
            "_id": this.props.id.match.params.id,
            "clinic_master_id": this.state.data.clinic_master_id._id,
            "local_start_time": this.state.time,
            "local_date_string": this.state.start_date,
            "start": this.state.start_date,
            "end": this.state.start_date,
            "clinic_id": this.state.data.clinic_id._id
        }).then(json => {
            var msgcolor = {message: "Test Request has been Approved!", color: "success"};
            this.props.id.generateNotification(msgcolor);
            this.props.id.history.push(dashboardRouter('/appointment/requests'))
        });
    }

    onCancel() {
        api.acceptTest({
            "_id": this.props.id.match.params.id,
            "clinic_master_id": this.state.data.clinic_master_id._id,
            "status": "Declined",
            "clinic_id": this.state.data.clinic_id._id
        }).then(json => {
            var msgcolor = {message: "Test Request has been Cancelled!", color: "success"};
            this.props.id.generateNotification(msgcolor);
            this.props.id.history.push(dashboardRouter('/appointment/requests'))
        });
        this.props.id.history.push(dashboardRouter('/appointment/requests'))

    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {

            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data) {
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <DateRange/>
                                            </GridItem>
                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Test Request</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={8}>

                                            <GridItem>
                                                <h2>{data && data && data.user_id ? data.user_id.name : "No Name"}</h2>
                                            </GridItem>

                                            <GridItem>

                                                <GridItem>
                                                    <h5>
                                                        <b>{data && data.gender ? titleCase(data.gender) : "NA"}

                                                            {data.user_id.age ? ", " + data.user_id.age + " years" : ""}

                                                        </b>

                                                    </h5>
                                                    <h5>
                                                        <b>{data && data && data.user_id ? data.user_id.contact : "No Contact"}</b>
                                                    </h5>
                                                    <h5>
                                                        <b>{data && data && data.user_id ? data.user_id.email : "No Email"}</b>
                                                    </h5>
                                                </GridItem>
                                                <GridItem>
                                                    <h5>
                                                        <b>Booked
                                                            at: {data && data.created_at ? getDateConverter(data.created_at) : null}</b>
                                                    </h5>
                                                </GridItem>
                                                <br/><br/>
                                                <GridItem>
                                                    <h4>
                                                        <b>Tests Booked:</b>
                                                    </h4>
                                                    {data.clinic_test_ids.map((x) => {
                                                        return <h5
                                                            key={Math.random()}> {x.name} </h5>
                                                    })}
                                                </GridItem>
                                                {/*<GridItem>
                                                    <h5>
                                                        <b>Test: {data && data.clinic_test_ids ? data.clinic_test_ids[0].name : null}</b>
                                                    </h5>
                                                </GridItem>*/}
                                                <br/>
                                                <GridItem>
                                                    <h5>
                                                        <b>Total:
                                                            INR
                                                            (₹) {data && data.clinic_test_ids ? data.total : null}</b>
                                                    </h5>
                                                </GridItem>
                                                {/*<GridItem>*/}
                                                {/*<h5>*/}
                                                {/*<b>Doctor: {data && data.doctor_id ? data.doctor_id.user_id.name : null}</b>*/}
                                                {/*</h5>*/}
                                                {/*</GridItem>*/}
                                                {/*<GridItem>*/}
                                                {/*<h5>*/}
                                                {/*<b>Service: {data && data.service_id ? data.service_id.service : null}</b>*/}
                                                {/*</h5>*/}
                                                {/*</GridItem>*/}
                                                {data && data.notes ?
                                                    <GridItem>
                                                        <h5>
                                                            <b>Reason: {data.notes}</b>
                                                        </h5>
                                                    </GridItem> : null}
                                                <GridItem>
                                                    <h5>
                                                        <b>Status: {data && data.status ? data.status : null}</b>
                                                    </h5>
                                                </GridItem>
                                                {Auth.isSuperAdminDashboard() ? <GridItem>
                                                    <h5>
                                                        <b>Clinic: {data && data.clinic_id ? data.clinic_id.name : null}</b>
                                                    </h5>
                                                </GridItem> : null}
                                                {data.sample_collection_address ? <GridItem>
                                                    <h5>
                                                        <b>Patient
                                                            Address: {data && data.sample_collection_address ? data.sample_collection_address.addressline + " ," + data.sample_collection_address.locality + " ," + data.sample_collection_address.city + " ," + data.sample_collection_address.state + " ," + data.sample_collection_address.pincode : null}</b>
                                                    </h5>
                                                </GridItem> : null}
                                                {data.payment_id ? <GridItem>
                                                    <h5>
                                                        <b>Payment Amount: {data.payment_id.amount}</b><br/>
                                                        <b>Payment Status: {data.payment_id.status}</b><br/>
                                                        <b>Payment Transaction ID: {data.payment_id.transaction_id}</b>
                                                    </h5>
                                                </GridItem> : null}
                                            </GridItem>

                                            <GridItem>

                                                <br/>
                                            </GridItem>

                                        </GridItem>
                                        <GridItem xs={12} sm={4}>
                                            <GridItem>
                                                <br/>
                                                <h3>{getDateConverter(data.local_date_string)}, {data.local_start_time}</h3>
                                            </GridItem>
                                            <br/><br/>
                                            {data && data.status === "Created" || data.status === "Booked" ?
                                                <GridItem>
                                                    <CustomInput
                                                        labelText="Notes"
                                                        success={this.state.usernameState === "success"}
                                                        error={this.state.usernameState === "error"}
                                                        id="notes"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "notes", "novalidation")
                                                        }}
                                                    />
                                                </GridItem> : null}
                                            <GridItem>
                                                <FormControl fullWidth>
                                                    <Datetime
                                                        timeFormat={false}
                                                        value={this.state.start_date}
                                                        // defaultValue={new Date()}
                                                        dateFormat={"DD MMMM, YYYY"}
                                                        closeOnSelect={true}
                                                        name="start_date"
                                                        onChange={event => this.handleChangeStartDate(event)}
                                                        inputProps={{placeholder: "Start Date"}}/>
                                                </FormControl>
                                            </GridItem>
                                            <GridItem>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="time"
                                                        className={classes.selectLabel}>
                                                        Select Time
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.time}
                                                        onChange={e => this.onChangeSelect(e)}
                                                        inputProps={{
                                                            name: "time",
                                                            id: "time"
                                                        }}> <MenuItem
                                                        disabled
                                                        classes={{
                                                            root: classes.selectMenuItem
                                                        }}>
                                                        Select Time </MenuItem>
                                                        {timings.map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             value={item.value}>
                                                                {item.time}  </MenuItem>
                                                        })}
                                                    </Select></FormControl>
                                            </GridItem>
                                            {data && data.status === "Created" || data.status === "Booked" ? <GridItem>
                                                <Button className="width-full"
                                                        color="warning"
                                                        onClick={() => this.onAccept()}>
                                                    <Icon>check</Icon>
                                                    <span style={{paddingLeft: 10}}>Approve</span>
                                                </Button>
                                                <br/>
                                                {/*<NavLink*/}
                                                {/*to={`/package/update/${data._id}`}>*/}
                                                <Button className="width-full"
                                                        color="grey" onClick={() => this.onCancel()}>
                                                    <Icon>close</Icon>
                                                    <span style={{paddingLeft: 10}}>Cancel</span>
                                                </Button> <br/><br/> <Button className="width-full"
                                                                             color="grey"
                                                                             onClick={() => this.generateLink()}>
                                                <span style={{paddingLeft: 10}}>Send
                                                Payment Link</span>
                                            </Button>
                                                {/*</NavLink>*/}
                                                <br/>
                                            </GridItem> : <div><Button className="width-full"
                                                                       color="warning"
                                                                       onClick={() => this.onAccept()}>
                                                <Icon>check</Icon>
                                                <span style={{paddingLeft: 10}}>Update</span>
                                            </Button><br/>
                                                <Button className="width-full"
                                                        color="grey"
                                                        onClick={() => this.generateLink()}>
                                                <span style={{paddingLeft: 10}}>Send
                                                Payment Link</span>
                                                </Button></div>}
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        } else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        } else return (
            <div>
                <Loader/>
            </div>
        )
    }
}

const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OneTestRequest));



// WEBPACK FOOTER //
// ./src/components/Tests/oneTestRequest.jsx